export default __webpack_public_path__ + "static/unicorn-contact-us-c5de51621727d76d06a82cf36f0a6c93.webp";